import { Parser } from "@siteimprove/alfa-parser";
import { Predicate } from "@siteimprove/alfa-predicate";
import { String } from "@siteimprove/alfa-string";
import { Token } from "../../syntax/index.js";
import { Ident } from "./ident.js";
const { map } = Parser;
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident}
 *
 * @public
 */
export class CustomIdent extends Ident {
    static of(value) {
        return new CustomIdent(value);
    }
    constructor(value) {
        super("custom-ident", value);
    }
    equals(value) {
        return value instanceof CustomIdent && super.equals(value);
    }
}
/**
 * @public
 */
(function (CustomIdent) {
    function isCustomIdent(value) {
        return value instanceof CustomIdent;
    }
    CustomIdent.isCustomIdent = isCustomIdent;
    const illegalCustomIdents = ["initial", "inherit", "unset", "default"];
    function parse(predicate = () => true) {
        return map(Token.parseIdent((ident) => !illegalCustomIdents.includes(String.toLowerCase(ident.value)) &&
            predicate(ident.value)), (ident) => CustomIdent.of(ident.value));
    }
    CustomIdent.parse = parse;
})(CustomIdent || (CustomIdent = {}));
//# sourceMappingURL=custom-ident.js.map